import { render, staticRenderFns } from "./kv-custom-field.vue?vue&type=template&id=4c0da394"
import script from "./kv-custom-field.vue?vue&type=script&lang=js"
export * from "./kv-custom-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports